import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import Quill from 'quill';

import * as Model from '../model.js';
import appView from './appView.js';
import * as Database from './database.js';
import previewView from './markups.js';
import {
  TODO_TITLE_LIMIT,
  TODOSUCESS,
  FAILEDMESSAGE,
  SUCCESSUPDATE,
  QUILLMINIMAL,
  NOCOMPLETEDTASK,
  NOIMPORTANTTASK,
  EMPTYTASK,
  ITEMSDELETED,
} from '../config.js';

class Todo extends appView {
  _quill;
  _titleMaxLength = 100;
  _descriptionMaxLength = 500;
  _parentElement = document.querySelector('.todo-inbox');
  _searchItemsElement = document.querySelectorAll('.todo-box .todo-item');
  _listBtns = document.querySelectorAll('.list-actions');
  _addTodoBtn = document.querySelector('.add-task');
  _containterItem = '.todo-item';
  _errorMsg = 'Empty Task, Add a new Task!';
  _message = 'Note was deleted successfully';
  _isQuill;

  constructor() {
    super();
    this.isEdit = false;
    this.todoId = null;
    this.important = null;
    this.completed = null;
    this.trash = null;
    this.newMarkup = true;
    this.initialize();
  }

  async initialize() {
    try {
      await this._setupEventListeners();
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async _setupEventListeners() {
    await this.getAllItems();

    this._deleteEmptyNoteEL();
    this._deleteAllTrashItems();
    this._initializeCount();
    this.toggleMenuViews();
    this._taskViewScroll();
    this._quillEditor();
    this._menuOverlayToggle();
    this._addTaskModal();
    this._handleTabLinkClick();
    this._checkEmptyTodos();
    this._addNewTask();
  }

  _taskViewScroll() {
    const taskEl = document.querySelector('.task-text');
    const taskBox = document.querySelector('.todo-box-scroll');
    const taskScroll = document.querySelector('.todoList-sidebar-scroll');
    if (taskEl)
      new PerfectScrollbar(taskEl, {
        wheelSpeed: 0.5,
        swipeEasing: !0,
        minScrollbarLength: 40,
        maxScrollbarLength: 300,
        suppressScrollX: true,
      });

    if (taskBox)
      new PerfectScrollbar(taskBox, {
        suppressScrollX: true,
      });

    if (taskScroll)
      new PerfectScrollbar('.todoList-sidebar-scroll', {
        suppressScrollX: true,
      });
  }

  _addPrirorityLabel() {
    const prioritySelect = document.querySelectorAll(
      '.p-dropdown .p-label-group'
    );

    if (prioritySelect) {
      const self = this;
      prioritySelect.forEach(function (tag) {
        tag.addEventListener('click', async function (e) {
          const todoItem = e.target.closest('.todo-item');
          const parentItem = e.target
            .closest('.priority-dropdown')
            .querySelector('.dropdown-toggle');
          const getClass = tag.className;
          const getSplitclass = getClass.split(' ')[0];

          if (tag.classList.contains('warning')) {
            parentItem.classList.remove('danger');
            parentItem.classList.remove('primary');
            parentItem.classList.add(getSplitclass);
          } else if (tag.classList.contains('danger')) {
            parentItem.classList.remove('warning');
            parentItem.classList.remove('primary');
            parentItem.classList.add(getSplitclass);
          } else if (tag.classList.contains('primary')) {
            parentItem.classList.remove('warning');
            parentItem.classList.remove('danger');
            parentItem.classList.add(getSplitclass);
          }

          //   const newPriority = parentItem.classList.contains(getSplitclass);
          const todoId = todoItem.getAttribute('data-id');
          const newData = {
            priority: getSplitclass,
          };

          try {
            await Database.updateItemInDatabase(todoId, 'todo', newData);
            self.successMessageInfo(SUCCESSUPDATE);
          } catch (error) {
            self.failedMessageInfo(FAILEDMESSAGE);
          }
        });
      });
    }
  }

  _quillEditor() {
    const taskDescription = document.querySelector('#taskdescription');

    if (taskDescription)
      this._quill = new Quill(taskDescription, {
        modules: {
          toolbar: {
            container: QUILLMINIMAL,
          },
        },
        placeholder: 'Compose an epic...',
        theme: 'snow', // or 'bubble'
      });
  }

  _resetFieldModal() {
    const taskModal = document.getElementById('addTaskModal');
    const self = this;
    if (taskModal) {
      taskModal.addEventListener('hidden.bs.modal', function (e) {
        const inputElements = this.querySelectorAll('input, textarea, select');
        inputElements.forEach(element => (element.value = ''));
        self._quill.deleteText(0, 2000);
      });
      self._resetEditStateAndTodoId();
    }
  }

  _menuOverlayToggle() {
    const mailMenu = document.querySelectorAll('.mail-menu');
    const mailOverlay = document.querySelectorAll('.mail-overlay');

    if (mailMenu)
      mailMenu.forEach(menu => {
        menu.addEventListener('click', function () {
          document
            .querySelectorAll('.tab-title')
            .forEach(title => title.classList.add('mail-menu-show'));
          document
            .querySelectorAll('.mail-overlay')
            .forEach(overlay => overlay.classList.add('mail-overlay-show'));
        });
      });

    if (mailOverlay)
      mailOverlay.forEach(overlay => {
        overlay.addEventListener('click', function () {
          document
            .querySelectorAll('.tab-title')
            .forEach(title => title.classList.remove('mail-menu-show'));
          document
            .querySelectorAll('.mail-overlay')
            .forEach(overlay => overlay.classList.remove('mail-overlay-show'));
        });
      });
  }

  _addTaskModal() {
    const addTask = document.getElementById('addTask');
    const self = this;

    if (addTask)
      addTask.addEventListener('click', function (event) {
        event.preventDefault();
        self._resetFieldModal();

        self._addTodoBtn.textContent = self.isEdit ? 'Save' : 'Add';

        $('#addTaskModal').modal('show');
        const ps = new PerfectScrollbar('.todo-box-scroll', {
          suppressScrollX: true,
        });
      });
  }

  _addNewTask() {
    const addBtn = document.querySelector('.add-task');
    const self = this;

    if (addBtn) {
      addBtn.addEventListener('click', async function (e) {
        if (!self._validateTodoInput()) return;

        const options = {
          todoId: self.todoId,
          important: self.important,
          completed: self.completed,
          trash: self.trash,
        };

        console.log(options);

        const data = self.isEdit
          ? Model.editTodos(self._quill, options)
          : Model.createTodos(self._quill);

        try {
          self.isEdit
            ? await Database.updateItemInDatabase(self.todoId, 'todo', data)
            : await Database.addItemtoDatabase(data, 'todo');

          self.successMessageInfo(TODOSUCESS);
          await self.displayTodos(data, true);
        } catch (err) {
          self.failedMessageInfo(FAILEDMESSAGE);
        } finally {
          $('#addTaskModal').modal('hide');
          //   self._resetFieldModal();
        }
      });
    }
  }

  async displayTodos(data, newTodo = false) {
    try {
      if (newTodo) {
        this.removeEmptyContainer();
        this.render(data);
      } else if (!newTodo && this._parentElement) {
        for (const todo of data) {
          await this.render(todo);
        }
      }
    } catch (err) {
      self.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _generateMarkup(data, options, dataNew) {
    const newDate = this.formatDate(data.date, dataNew);

    let important = '';
    let completed = '';
    let edited = '';

    const trash = options.trash ? 'todo-task-trash' : '';
    const isCompleted = options.completed ? 'Completed:' : '';

    if (options.trash !== 1) {
      important = options.important ? 'todo-task-important' : '';
      completed = options.completed ? 'todo-task-done' : '';
    }

    if (data.completed !== 1) {
      edited = data.isEdited ? 'Edited:' : '';
    }

    const limitTitle = this.limitCharacters(data.title, TODO_TITLE_LIMIT);

    const markup = previewView.todoMarkup(data, {
      newDate: newDate,
      limitTitle: limitTitle,
      important: important,
      completed: completed,
      trash: trash,
      edited: edited,
      isCompleted: isCompleted,
    });

    return markup;
  }

  async getAllItems() {
    try {
      const data = await Database.getAllItemsFromDatabase('todo');
      const sortedItems = this.sortDataByTimestamp(data);
      await this.displayTodos(sortedItems);
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async render(data, dataNew = true) {
    try {
      const [isImportant, isTrash, isCompleted] = await Promise.all([
        Database.getItemValueFromDatabase(data.id, 'important', 'todo'),
        Database.getItemValueFromDatabase(data.id, 'trash', 'todo'),
        Database.getItemValueFromDatabase(data.id, 'completed', 'todo'),
      ]);

      const options = {
        important: isImportant,
        trash: isTrash,
        completed: isCompleted,
      };

      if (!data || (Array.isArray(data) && data.length === 0))
        return this.renderErrorMessage();

      const containerElement = this._parentElement.querySelector(
        `.todo-item[data-id="${data.id}"]`
      );

      const markup = this._generateMarkup(data, options, dataNew);

      if (!this.newMarkup) {
        this.update(data, markup, containerElement);
        this._renderFunctions();
        return;
      }

      // $('#ct').prepend(markup);
      const element = this._parentElement.querySelector('.todo-box-scroll');
      element.insertAdjacentHTML('afterbegin', markup);
      this._renderFunctions();
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _initializeCount() {
    const todoBadgeManager = new TodoBadgeManager();
    todoBadgeManager.dynamicBadgeNotification('allList');
    todoBadgeManager.dynamicBadgeNotification('completedList');
    todoBadgeManager.dynamicBadgeNotification('importantList');
  }

  _renderFunctions() {
    this._checkCheckbox();
    this._reviveMailDropdown();
    this._addPrirorityLabel();
    this._deleteDropdown();
    this._editDropdown();
    this._todoItem();
    this._markTaskImportant();
    this._deleteTodo();
    const noteEl = document.querySelectorAll('.todo-item');
    this._searchLists(noteEl);
    this._initializeCount();
  }

  _checkCheckbox() {
    const checkBox = document.querySelectorAll(
      '.todo-item input[type="checkbox"]'
    );

    if (checkBox) {
      const self = this;
      checkBox.forEach(checkbox => {
        checkbox.addEventListener('click', async function (e) {
          const doneBtn = document.getElementById('todo-task-done');
          const todoItem = this.closest('.todo-item');
          const completed = todoItem.getAttribute('data-completed');
          const todoID = todoItem.getAttribute('data-id');
          const newData = {
            completed: completed === '0' ? 1 : 0,
          };
          try {
            await Database.updateItemInDatabase(todoID, 'todo', newData);
            if (this.checked && completed === '0') {
              todoItem.classList.add('todo-task-done');
              todoItem.setAttribute('data-completed', '1');
            } else {
              todoItem.classList.remove('todo-task-done');
              todoItem.setAttribute('data-completed', '0');
              if (doneBtn.classList.contains('active')) {
                todoItem.style.display = 'none';

                await new Promise(resolve => setTimeout(resolve, 100));

                const filterFunction = item => item.important === 1;
                const data = await Database.getAllItemsFromDatabase(
                  'todo',
                  filterFunction
                );
                if (data.length === 0) {
                  return self._renderEmptyText(NOCOMPLETEDTASK);
                }
              } else {
                todoItem.style.display = '';
              }
            }
            self.successMessageInfo(SUCCESSUPDATE);
          } catch (err) {
            self.failedMessageInfo(FAILEDMESSAGE);
          } finally {
            const todoBadgeManager = new TodoBadgeManager();
            todoBadgeManager.dynamicBadgeNotification('completedList');
          }
        });
      });
    }
  }

  _deleteDropdown() {
    const dropdowns = document.querySelectorAll(
      '.action-dropdown .dropdown-menu .delete.dropdown-item'
    );

    if (dropdowns) {
      const self = this;
      dropdowns.forEach(item => {
        item.addEventListener('click', async function () {
          const todoItem = this.closest('.todo-item');
          const todoID = todoItem.getAttribute('data-id');
          const isTrash = todoItem.getAttribute('data-trash');
          const newData = {
            trash: isTrash === '0' ? 1 : 0,
          };

          if (!todoItem.classList.contains('todo-task-trash')) {
            const classes = todoItem.classList;
            const [_, firstClass, secondClass, thirdClass] = classes;

            if (firstClass === 'all-list') {
              todoItem.classList.remove(firstClass);
            }

            if (
              secondClass === 'todo-task-done' ||
              secondClass === 'todo-task-important'
            ) {
              todoItem.classList.remove(secondClass);
            }

            if (
              thirdClass === 'todo-task-done' ||
              thirdClass === 'todo-task-important'
            ) {
              todoItem.classList.remove(thirdClass);
            }

            try {
              await Database.updateItemInDatabase(todoID, 'todo', newData);
              todoItem.classList.add('todo-task-trash');
              todoItem.setAttribute('data-trash', '1');
              todoItem.style.display = 'none';
              self.successMessageInfo(ITEMSDELETED);
            } catch (error) {
              self.failedMessageInfo(FAILEDMESSAGE);
            } finally {
              if (self._checkEmptyTodos()) return self.renderErrorMessage();
            }
          }

          const todoBadgeManager = new TodoBadgeManager();
          todoBadgeManager.dynamicBadgeNotification('allList');
          todoBadgeManager.dynamicBadgeNotification('completedList');
          todoBadgeManager.dynamicBadgeNotification('importantList');
        });
      });
    }
  }

  async _deleteTodo() {
    try {
      const deleteBtns = document.querySelectorAll('.permanent-delete');
      const self = this;
      deleteBtns.forEach(function (del) {
        del.addEventListener('click', function (e) {
          e.preventDefault();
          self.openModal('#todoDelete');
          $('.delete-todo').on('click', function () {
            self.handleTodoDeletion(e);
          });
        });
      });
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async handleTodoDeletion(e) {
    console.log('dont call me');
    const note = e.target.closest('.todo-item');
    const dataId = note.getAttribute('data-id');
    try {
      const request = await Database.deleteItemFromDatabase(dataId, 'todo');
      if (request) {
        note.remove();
        this.successMessageInfo(ITEMSDELETED);
        this.closeModal('#todoDelete', this._message, true);
      }
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    } finally {
      const storeLength = await Database.getObjectStoreLength('todo');
      if (storeLength === 0) this.renderErrorMessage('Empty Trash');
      $('#todoDelete').modal('hide');
    }
  }

  _markTaskImportant() {
    const dropdowns = document.querySelectorAll(
      '.action-dropdown .dropdown-menu .important'
    );

    if (dropdowns) {
      const self = this;

      dropdowns.forEach(item => {
        item.addEventListener('click', async function (event) {
          event.preventDefault();
          const importantBtn = document.getElementById('todo-task-important');
          const todoItem = this.closest('.todo-item');
          const todoID = todoItem.getAttribute('data-id');
          const changeText = this.closest('.important');
          const isImportant = todoItem.getAttribute('data-important');
          const newData = {
            important: isImportant === '0' ? 1 : 0,
          };

          try {
            await Database.updateItemInDatabase(todoID, 'todo', newData);
            if (isImportant === '0') {
              todoItem.classList.add('todo-task-important');
              todoItem.setAttribute('data-important', '1');
              changeText.textContent = 'Mark as Normal';
            } else {
              todoItem.classList.remove('todo-task-important');
              todoItem.setAttribute('data-important', '0');
              changeText.textContent = 'Mark as Important';
              if (importantBtn.classList.contains('active')) {
                todoItem.style.display = 'none';

                await new Promise(resolve => setTimeout(resolve, 100));

                const filterFunction = item => item.completed === 1;
                const data = await Database.getAllItemsFromDatabase(
                  'todo',
                  filterFunction
                );
                if (data.length === 0) {
                  return self._renderEmptyText(NOIMPORTANTTASK);
                }
              } else {
                todoItem.style.display = '';
              }
            }
            self.successMessageInfo(SUCCESSUPDATE);
          } catch (error) {
            self.failedMessageInfo(FAILEDMESSAGE);
          }

          const todoBadgeManager = new TodoBadgeManager();
          todoBadgeManager.dynamicBadgeNotification('importantList');
        });
      });
    }
  }

  _checkEmptyTodos() {
    const todos = document.querySelectorAll(
      '.todo-item.all-list:not(.todo-task-trash)'
    );
    if (todos && todos.length === 0) {
      this.renderErrorMessage();
      return true;
    } else {
      this.removeEmptyContainer();
    }
  }

  _renderEmptyText(message) {
    const deleteBtn = document.querySelector('.delete-all-items');
    this.removeEmptyContainer();
    this.renderErrorMessage(message);
    deleteBtn.style.display = 'none';
  }

  _deleteEmptyNoteEL() {
    const listActions = document.querySelectorAll('.list-actions');

    if (listActions) {
      const self = this;
      listActions.forEach(list => {
        list.addEventListener('click', function () {
          const allList = document.querySelectorAll(
            '.todo-item.all-list:not(.todo-task-trash)'
          );
          const allDoneTask = document.querySelectorAll('.todo-task-done');
          const importantTask = document.querySelectorAll(
            '.todo-task-important'
          );
          const trashTask = document.querySelectorAll('.todo-task-trash');
          const deleteBtn = document.querySelector('.delete-all-items');

          if (list.id === 'todo-task-trash' && trashTask.length === 0) {
            self._renderEmptyText('Empty Trash');
          } else if (list.id === 'todo-task-trash' && trashTask.length !== 0) {
            self.removeEmptyContainer();
            deleteBtn.style.display = 'block';
          } else if (list.id === 'todo-task-done' && allDoneTask.length === 0) {
            self._renderEmptyText(NOCOMPLETEDTASK);
          } else if (
            list.id === 'todo-task-important' &&
            importantTask.length === 0
          ) {
            self._renderEmptyText(NOIMPORTANTTASK);
          } else if (allList.length === 0) {
            self._renderEmptyText(EMPTYTASK);
          } else {
            self.removeEmptyContainer();
            deleteBtn.style.display = 'none';
          }
        });
      });
    }
  }

  _getAllTrashItems() {
    const todos = document.querySelectorAll('.todo-task-trash');
    const itemsToDelete = [];

    if (todos) {
      todos.forEach(todo => {
        const todoAttr = todo.getAttribute('data-id');
        itemsToDelete.push(todoAttr);
      });
    }

    return itemsToDelete;
  }

  _removeAllTrashItems() {
    const todos = document.querySelectorAll('.todo-task-trash');
    if (todos) {
      todos.forEach(todo => {
        todo.remove();
      });
    }
  }

  _deleteAllTrashItems() {
    const deleteBtn = document.querySelector('.delete-all-items');

    if (deleteBtn) {
      const self = this;
      deleteBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.openModal('#todoDelete');
        $('.delete-todo').on('click', async function () {
          try {
            await self._completeDeletingItems();
            self._removeAllTrashItems();
            deleteBtn.style.display = 'none';
          } catch (err) {
            self.failedMessageInfo(FAILEDMESSAGE);
          } finally {
            $('#todoDelete').modal('hide');
            self.renderErrorMessage('Empty Trash');
          }
        });
      });
    }
  }

  async _completeDeletingItems() {
    const trashItems = this._getAllTrashItems();
    try {
      if (trashItems) {
        await Database.deleteMultipleItemsFromDatabase(trashItems, 'todo');
        this.successMessageInfo(ITEMSDELETED);
      }
    } catch (err) {
      throw err;
    }
  }

  _reviveMailDropdown() {
    const dropdowns = document.querySelectorAll(
      '.action-dropdown .dropdown-menu .revive.dropdown-item'
    );

    if (dropdowns) {
      const self = this;
      dropdowns.forEach(item => {
        item.addEventListener('click', async function (event) {
          event.preventDefault();

          if (self._checkEmptyTodos()) return self.renderErrorMessage();

          const todoItem = this.closest('.todo-item');
          const todoID = todoItem.getAttribute('data-id');
          const isTrash = todoItem.getAttribute('data-trash');
          const trashBtn = document.getElementById('todo-task-trash');
          const newData = {
            trash: isTrash === '0' ? 1 : 0,
          };

          if (todoItem.classList.contains('todo-task-trash')) {
            const classes = todoItem.classList;
            const [_, secondClass] = classes;

            try {
              await Database.updateItemInDatabase(todoID, 'todo', newData);
              todoItem.classList.remove(secondClass);
              todoItem.classList.add('all-list');
              todoItem.setAttribute('data-trash', '0');
              todoItem.style.display = 'none';
              if (trashBtn.classList.contains('active')) {
                todoItem.style.display = 'none';

                await new Promise(resolve => setTimeout(resolve, 100));

                const filterFunction = item => item.trash === 1;
                const data = await Database.getAllItemsFromDatabase(
                  'todo',
                  filterFunction
                );
                if (data.length === 0) {
                  return self._renderEmptyText('Empty Trash');
                }
              } else {
                todoItem.style.display = '';
              }
              self.successMessageInfo(SUCCESSUPDATE);
            } catch (error) {
              self.failedMessageInfo(FAILEDMESSAGE);
            }
          }

          const todoBadgeManager = new TodoBadgeManager();
          todoBadgeManager.dynamicBadgeNotification('allList');
          todoBadgeManager.dynamicBadgeNotification('completedList');
          todoBadgeManager.dynamicBadgeNotification('importantList');
        });
      });
    }
  }

  //   _convertTextToJson(text) {
  //     const paragraphs = text.split('\n');
  //     const ops = paragraphs.map(paragraph => ({ insert: paragraph }));
  //     const jsonContent = { ops };
  //     return jsonContent;
  //   }

  _convertHtmlToJson(htmlString) {
    const delta = this._quill.clipboard.convert(htmlString);
    const opsArray = delta.ops;

    return opsArray;
  }

  _resetEditStateAndTodoId() {
    this.isEdit = false;
    this.todoId = null;
    this.important = null;
    this.completed = null;
    this.trash = null;
    this.newMarkup = true;
  }

  _setEditStateAndTodoId(taskTitle) {
    this.isEdit = true;
    this.todoId = taskTitle.getAttribute('data-id');
    this.important = +taskTitle.getAttribute('data-important');
    this.completed = +taskTitle.getAttribute('data-completed');
    this.trash = +taskTitle.getAttribute('data-trash');
    this.newMarkup = false;
  }

  _editDropdown() {
    const dropdowns = document.querySelectorAll(
      '.action-dropdown .dropdown-menu .edit.dropdown-item'
    );

    const self = this;

    if (dropdowns)
      dropdowns.forEach(item => {
        item.addEventListener('click', function (event) {
          event.preventDefault();

          const taskTitle = this.closest('.todo-item')
            .querySelector('.todo-heading')
            .getAttribute('data-todoHeading');
          const taskText = this.closest('.todo-item')
            .querySelector('.todo-text')
            .getAttribute('data-todoText');

          const getPriority = this.closest('.todo-item')
            .querySelector('.dropdown-toggle')
            .className.split(' ')[1];

          const taskJson = self._convertHtmlToJson(taskText);
          const todoItem = this.closest('.todo-item');

          self._setEditStateAndTodoId(todoItem);

          document.getElementById('priority').value = getPriority;
          document.querySelector('#task-text').value = taskTitle;
          self._quill.setContents(taskJson);

          self._addTodoBtn.textContent = self.isEdit ? 'Save' : 'Add';

          $('#addTaskModal').modal('show');
        });
      });
  }

  _todoItem() {
    const todoItem = document.querySelectorAll('.todo-item .todo-content');

    if (todoItem)
      todoItem.forEach(item => {
        item.addEventListener('click', function (event) {
          event.preventDefault();

          const taskTitle =
            this.querySelector('.todo-heading').getAttribute(
              'data-todoHeading'
            );
          const taskHtml =
            this.querySelector('.todo-text').getAttribute('data-todoHtml');

          document.querySelector('.task-heading').textContent = taskTitle;
          document.querySelector('.task-text').innerHTML = taskHtml;

          $('#todoShowListItem').modal('show');
        });
      });
  }

  _handleTabLinkClick() {
    const tabLinks = document.querySelectorAll(
      '.tab-title .nav-pills a.nav-link'
    );

    if (tabLinks)
      tabLinks.forEach(link => {
        link.addEventListener('click', function (event) {
          const mailBoxContainer = this.closest('.mail-box-container');

          if (mailBoxContainer) {
            mailBoxContainer
              .querySelector('.tab-title')
              .classList.remove('mail-menu-show');
            mailBoxContainer
              .querySelector('.mail-overlay')
              .classList.remove('mail-overlay-show');
          }
        });
      });
  }

  _validateTodoInput() {
    const getValidationField =
      document.getElementsByClassName('validation-text');
    const getTodoTitleInput = document.getElementById('task');
    const getTodoDescriptionInput = document.getElementById('taskdescription');
    this._isQuill = true;

    const result = this.validateInput(
      getValidationField,
      getTodoTitleInput,
      getTodoDescriptionInput
    );

    this._isQuill = false;
    return result;
  }
}

new Todo();

class TodoBadgeManager extends appView {
  constructor() {
    super();
    if (typeof jQuery !== 'undefined') {
      this.todoListElements = $('.todo-item.all-list');
      this.completedTaskElements = $('.todo-item.todo-task-done');
      this.importantTaskElements = $('.todo-item.todo-task-important');
      this.badgeTodoAllListDiv = $('#all-list .todo-badge');
      this.badgeCompletedTaskListDiv = $('#todo-task-done .todo-badge');
      this.badgeImportantTaskListDiv = $('#todo-task-important .todo-badge');
    }
  }

  dynamicBadgeNotification(todoCategoryCount) {
    let categoryElements, categoryBadgeDiv;

    if (todoCategoryCount === 'allList') {
      categoryElements = this.todoListElements;
      categoryBadgeDiv = this.badgeTodoAllListDiv;
    } else if (todoCategoryCount === 'completedList') {
      categoryElements = this.completedTaskElements;
      categoryBadgeDiv = this.badgeCompletedTaskListDiv;
    } else if (todoCategoryCount === 'importantList') {
      categoryElements = this.importantTaskElements;
      categoryBadgeDiv = this.badgeImportantTaskListDiv;
    }

    const categoryElementsCount = categoryElements?.length;
    console.log(categoryElementsCount);

    if (categoryElementsCount === 0) {
      categoryBadgeDiv.text('');
      return;
    }

    if (categoryElementsCount > 9) {
      categoryBadgeDiv.css({
        padding: '2px 0px',
        height: '25px',
        width: '25px',
      });
    } else {
      categoryBadgeDiv?.removeAttr('style');
    }

    categoryBadgeDiv?.text(categoryElementsCount);
  }
}
